import axios from "axios";
import CryptService from "@/services/CryptService";
import { isRemember } from "@/helper/RememberMe";
import jwtDecode from "jwt-decode";

export default class AuthService {
  private static getStorage() {
    return isRemember() ? localStorage : sessionStorage;
  }

  public static isAuthenticated(): boolean {
    const token: string = this.getToken();
    return !!token;
  }

  public static checkIsAuthenticated(): Promise<any> | null {
    if (this.isAuthenticated()) {
      const user: any = this.getUser();
      const promise: Promise<any> = axios.get("/users/" + String(user.id), {
        headers: {
          Authorization: "Bearer " + this.getToken(),
        },
      });

      promise.catch((error: any) => {
        this.clear();
      });

      return promise;
    }

    return null;
  }

  public static clear(): void {
    this.getStorage().removeItem("vuex");
    this.getStorage().removeItem("access_token");
    // window.dispatchEvent(
    //   new StorageEvent("storage", {
    //     key: "access_token",
    //     newValue: "",
    //   })
    // );
  }

  public static logout(): void {
    this.clear();

    window.dispatchEvent(
      new StorageEvent("storage", {
        key: "access_token",
        newValue: "",
      })
    );
  }

  public static getToken(): string {
    return this.getUserDataByKey("access_token");
  }

  public static setToken(token: string): void {
    this.setUserDataByKey("access_token", token);
  }

  public static setLogin(token: string): void {
    this.setToken(token);
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
  }

  public static getRoles(): Array<string> {
    const user = this.getUser();
    return user.roles;
  }

  public static isAdmin(): boolean {
    const adminRole = this.getRoles().find(
      (r: any) => r === "ROLE_ADMIN" || r === "ROLE_SUPER_ADMIN"
    );
    return !!adminRole;
  }

  // @ts-ignore
  private static getUserDataByKey(key: string): string {
    const value: string | null = this.getStorage().getItem(key);
    if (value === null) {
      return "";
    }
    try {
      return CryptService.decode(value.toString());
    } catch (e) {
      this.clear();
    }
  }

  private static setUserDataByKey(key: string, value: string): void {
    const ciphertext: string = CryptService.encode(value);

    this.getStorage().setItem(key, ciphertext);

    window.dispatchEvent(
      new StorageEvent("storage", {
        key: key,
        newValue: value,
      })
    );
  }

  public static setUser(data: any) {
    this.setLocalStore("user", data);
  }

  public static getUser(): any {
    const token = this.getToken();
    const decodedToken: any = jwtDecode(token);

    return decodedToken;
  }

  public static getUserId(): number | null {
    const user = this.getUser();
    return Number(user?.id);
    return null;
  }

  private static setLocalStore(key: string, data: any): void {
    if (data instanceof Object || data instanceof Array) {
      data = JSON.stringify(data);
    }
    const encryptedText: string = CryptService.encode(data as string);
    this.getStorage().setItem(key, encryptedText);

    window.dispatchEvent(
      new StorageEvent("storage", {
        key: key,
        newValue: data as string,
      })
    );
  }

  private static getLocalStore(key: string): any {
    const data: any | null = this.getStorage().getItem(key);

    if (data === null) {
      return "";
    }
    try {
      return JSON.parse(CryptService.decode(data));
    } catch (e) {
      this.clear();
    }
  }
}
